import React, { useEffect } from 'react'
import Header from './Components/Header'
import Batches from './Components/Batches'
import { GroupCourseDashboardEl } from './Elements'
import withStore from '../../../../../../Components/Unstated/withStore'
import CourseStore from '../../../../Store/CourseStore'
import { withStoreProvider } from '../../../../../../Helpers/withStoreProvider'
import DashboardBatchesStore from './Stores/DashboardBatchesStore'
import BatchTimings from './Components/BatchTimings/index'
import Participants from './Components/Participants/index'
import { withRouter } from 'react-router-dom'
import BatchTimingsStore from './Stores/BatchTimingsStore'

function GroupCourseDashboard({
  match: {
    params: { batchId },
  },
  courseStore: { state: courseDetails },
}) {
  const { setCourseId } = DashboardBatchesStore.useContainer()
  const { setBatchId, setUserType } = BatchTimingsStore.useContainer()

  useEffect(() => {
    setBatchId(batchId)
    setUserType(courseDetails.userType)
    setCourseId(courseDetails.id)
  }, [
    courseDetails.userType,
    courseDetails.id,
    batchId,
    setBatchId,
    setUserType,
    setCourseId,
  ])

  return (
    <GroupCourseDashboardEl>
      <Header courseDetails={courseDetails} />
      <div className='content'>
        <Batches userType={courseDetails.userType} />
        <div className='activeBatchDetails'>
          <BatchTimings />
          <Participants />
        </div>
      </div>
    </GroupCourseDashboardEl>
  )
}

export default withStore([CourseStore])(
  withStoreProvider([BatchTimingsStore, DashboardBatchesStore])(
    withRouter(GroupCourseDashboard),
  ),
)
